<template>
  <component :is="tagIs">
    <span class="detail-title">
      <slot> Difficulty </slot>
    </span>
    <span
      class="detail-value -difficulty"
      role="img"
      :aria-label="`${difficulty} out of ${maxDifficulty} Difficulty`"
    >
      <span class="value-icons" aria-hidden="true">
        <i
          v-for="difficultyNum in maxDifficulty"
          :key="`difficulty-${difficultyNum}`"
          class="material-symbols-outlined"
          :class="{ '-active': difficulty >= difficultyNum }"
          >local_fire_department</i
        >
      </span>
    </span>
  </component>
</template>

<script>
/**
 * Difficulty rating displayed as fire icons.
 */
export default {
  name: 'DifficultyRating',
  components: {},
  props: {
    tagIs: {
      type: String,
      default: 'li',
    },
    difficulty: {
      type: Number,
      required: true,
    },
    // cms defaults to 5
    maxDifficulty: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
}
</script>
